import type {RouteConfigPath} from '@famly/vet_navigation_route-config';

export const TOOLBAR_FORM = 'ACTIVITIES_TOOLBAR_FORM';
export const COMMENT_FORM = 'ACTIVITIES_COMMENT_FORM';

export const TABS = {
    FAMLY: 'FAMLY',
    PUBLIC: 'public',
    MINE: 'me',
};
export const FAMLY_ROUTE = '/account/institution/:institutionId/activities' satisfies RouteConfigPath;
export const STANDALONE_FAMLY_ROUTE = '/account/activities' satisfies RouteConfigPath;
export const LIBRARY_ROUTE =
    '/account/institution/:institutionId/activities/library/:libraryId' satisfies RouteConfigPath;
export const STANDALONE_LIBRARY_ROUTE = '/account/activities/library/:libraryId' satisfies RouteConfigPath;
